import React from "react";
import { Modal } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import Icon from "../../../common/Icon";
import { formatDate } from "../../../../utils/performerClientRegisters.utils";

interface DownloadModalProps {
  open: boolean;
  onClose: () => void;
  stateRegisters: any[];
  selectedStateRegisterQue: any;
  onclickDownloadExcel: (file: any) => void;
  onclickDownloadPdf: (file: any) => void;
  onClickDownloadZip: (url: any) => void;
}

const thStyle: React.CSSProperties = {
  padding: "14px 16px",
  fontWeight: 700,
  fontSize: "14px",
  color: "#1E1E1E",
  backgroundColor: "#EAF0F7",
  whiteSpace: "nowrap"
};

const tdStyle: React.CSSProperties = {
  padding: "14px 16px",
  fontWeight: 500,
  fontSize: "14px",
  color: "#1E1E1E",
  borderBottom: "1px solid #F3F3F3",
};

const DownloadModal: React.FC<DownloadModalProps> = ({
  open,
  onClose,
  stateRegisters,
  selectedStateRegisterQue,
  onclickDownloadExcel,
  onclickDownloadPdf,
  onClickDownloadZip,
}) => {
  return (
    <Modal open={open} onClose={onClose} sx={{ zIndex: 10200 }}>
      <div style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "max-content",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 24px 0 rgba(0, 0, 0, 0.10)",
        borderRadius: "8px",
        maxHeight: "90vh",
        display: "flex",
        flexDirection: "column",
        outline: "none",
      }}>

        {/* Header */}
        <div style={{
          padding: "16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexShrink: 0,
        }}>
          <div>
            <h4 style={{ margin: 0, fontSize: "20px", fontWeight: 600, color: "#1E1E1E" }}>
              Download Registers
            </h4>
            <p style={{ margin: "4px 0 0", fontSize: "14px", color: "#757575" }}>
              Select the register and download excel or pdf format
            </p>
          </div>
          <button
            onClick={onClose}
            style={{ background: "none", border: "none", cursor: "pointer", padding: "4px", color: "#6B7280", display: "flex", alignItems: "center" }}
          >
            <IoMdClose size={22} />
          </button>
        </div>

        <hr className="my-0 mx-3"/>

        {/* Scrollable table */}
        <div style={{ overflowY: "auto", flexGrow: 1, padding: "16px" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ ...thStyle, textAlign: "left" }}>Form Name</th>
                <th style={{ ...thStyle, textAlign: "left" }}>Download Excel</th>
                <th style={{ ...thStyle, textAlign: "left" }}>Download PDF</th>
                <th style={{ ...thStyle, textAlign: "left" }}>First Generated Date</th>
                <th style={{ ...thStyle, textAlign: "left" }}>Last Generated date</th>
                <th style={{ ...thStyle, textAlign: "left" }}>Total Generations</th>
              </tr>
            </thead>
            <tbody>
              {(stateRegisters || []).length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ padding: "32px", textAlign: "center", fontSize: "14px" }}>
                    No Data Available
                  </td>
                </tr>
              ) : (
                (stateRegisters || []).map((row: any, index: number) => (
                  <tr key={index}>
                    <td style={tdStyle}>{row.form_name || "NA"}</td>
                    <td style={{ ...tdStyle, textAlign: "left" }}>
                      {/* Some registers have a docx_url instead of an excel_url (the two
                          are mutually exclusive) — fall back to that so the download icon
                          still shows rather than a dash. */}
                      {(row.register_excel_url || row.register_docx_url) ? (
                        <Icon style={{ color: "#0654AD" }} type="button" name={"download"} text={"download"} action={() => onclickDownloadExcel(row)} />
                      ) : "-"}
                    </td>
                    <td style={{ ...tdStyle, textAlign: "left" }}>
                      {row.register_pdf_url ? (
                        <Icon style={{ color: "#0654AD" }} type="button" name={"download"} text={"download"} action={() => onclickDownloadPdf(row)} />
                      ) : "-"}
                    </td>
                    <td style={tdStyle}>
                      {formatDate(row.created_at).split(" ")[0]}
                      <br />
                      <span>{formatDate(row.created_at).split(" ")[1]}</span>
                    </td>
                    <td style={tdStyle}>
                      {formatDate(row.updated_at).split(" ")[0]}
                      <br />
                      <span>{formatDate(row.updated_at).split(" ")[1]}</span>
                    </td>
                    <td style={tdStyle}>{row.count || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Footer — two full-width buttons */}
        <div style={{ display: "flex", flexShrink: 0, padding: "16px", gap: "24px" }}>
          <button
            className="button-primary w-50"
            onClick={() => onClickDownloadZip(selectedStateRegisterQue && selectedStateRegisterQue.register_url)}
          >
            Download ZIP Excel
          </button>
          <button
            className="button-primary w-50"
            onClick={() => onClickDownloadZip(selectedStateRegisterQue && selectedStateRegisterQue.pdf_register_url)}
          >
            Download ZIP PDF
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DownloadModal;
